export class GridBookmark {
    constructor(
        public page:number,
        public pageSize:number,
        public search:string,
        public orderColumn:string,
        public orderDirection:string,
        public createDateMs:number)
    {}
}
